import { ConfigOption } from '@ngx-formly/core';
import { FormlyEmployeeHeaderCardWidgetComponent } from './modules/employee-header-card/formly-employee-header-card-widget/formly-employee-header-card-widget.component';

export const HRM_FORMLY_TYPES: ConfigOption['types'] = [
    { name: 'formly-employee-header-card', component: FormlyEmployeeHeaderCardWidgetComponent, wrappers: ['simple-title'] },
];
